module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"header":{"once":"Single Submission","accessLink":"Access Link"}}}')
  delete Component.options._Ctor
}
